import styled from "styled-components";

export const DropdownWrapper = styled.div`
  padding: 0;
  text-indent: 0;
  margin: 0 0 0.5rem 0;
  h3 {
    display: flex;
    width: 100%;
    padding: 15px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.dark};
    background-color: transparent;
    font-size: ${({ theme }) => theme.fontSize.m};
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    &:hover {
      opacity: 0.7;
    }
    &.active {
      background-color: ${({ theme }) => theme.colors.dark};
      color: ${({ theme }) => theme.colors.white};
    }
    &.finish {
      background-color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const DropdownContent = styled.div`
  overflow: hidden;
  max-height: 0px;
  visibility: hidden;
  transition: all 0.25s cubic-bezier(0.5, 0, 0.1, 1) 0s;
  text-align: left;
  width: 100%;
  max-width: 466px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  &.active {
    visibility: visible;
    max-height: 75rem;
  }
`;
